import React from 'react';
import CascadeObjectiveList from './cascade-okr-list';

const CascadeObjective = (props) => {
	const { cascadeList } = props;
	return (
		<div>
			{
				cascadeList != null && Object.keys(cascadeList).length
					? Object.keys(cascadeList).map((item, index) => (
						<CascadeObjectiveList 
						cascadeItem={cascadeList[item]} 
						goalDetPage={props.goalDetPage} 
						setTeamObjevtiveBool={props.setTeamObjevtiveBool} 
						key={index} />
					))
					: ''
			}
		</div>
	);
}

export default CascadeObjective;